__turbopack_context__.v({
  "className": "wVLSSa_className",
  "variable": "wVLSSa_variable",
});
